// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const cfgJson = process.env.REACT_APP_FIREBASE_CONFIG;

if (!cfgJson) {
  throw new Error("REACT_APP_FIREBASE_CONFIG is missing");
}

// Initialize Firebase
const app = initializeApp(JSON.parse(cfgJson));
export const auth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();
